export class DeviceCodeIdpRp {
  deviceCodeIdpRpId: number;
  naam: string;
  client_Id: string;
  client_Secret: string;
  redirectUri: string;
}
